export * from "@vaadin/dashboard/vaadin-dashboard-widget.js";
export * from './generated/DashboardWidget.js';
